import { academicCalendarItemBackgroundColors, TimelineAcademicCalendarIndicationProps } from '@modules/timetable';

export const TimelineAcademicCalendarIndication = ({
  academicCalendarItem,
  leftOffset,
  rightOffset,
}: TimelineAcademicCalendarIndicationProps) => {
  const backgroundStyle = `linear-gradient(150deg,${
    academicCalendarItem.type === 'academic'
      ? academicCalendarItemBackgroundColors.academic
      : academicCalendarItemBackgroundColors.holiday
  } 25%, #fff 25%,#fff 50%,${
    academicCalendarItem.type === 'academic'
      ? academicCalendarItemBackgroundColors.academic
      : academicCalendarItemBackgroundColors.holiday
  } 50%,${
    academicCalendarItem.type === 'academic'
      ? academicCalendarItemBackgroundColors.academic
      : academicCalendarItemBackgroundColors.holiday
  } 75%,
      #fff 75%,
      #fff 100%
    )`;
  return (
    <div
      key={academicCalendarItem.id}
      id={academicCalendarItem.id}
      className="time-slot"
      style={{
        left: leftOffset,
        width: rightOffset - leftOffset,
        backgroundImage: backgroundStyle,
        backgroundSize: '56.57px 32.57px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex:-99
      }}
    >
      <span className="timetable-academic-calendar-label">{academicCalendarItem.name}</span>
    </div>
  );
};
